import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';
import type { JobPipeline } from '@/types/pipeline';

export function useJobPipeline(id: string | undefined | null) {
  return useApiQuery<JobPipeline>({
    queryKey: jobPipelineKeys.detail(id ?? ''),
    queryFn: () => apiGet<JobPipeline>(operationsClient, jobPipelineEndpoints.detail(id as string)),
    enabled: Boolean(id),
  });
}
